import { useTranslate } from "@tolgee/react";
import {
  PLATFORM_COLORS,
  PLATFORM_DISPLAY_NAME_KEYS_WITH_ALL,
  PLATFORM_ICONS,
} from "../../../../config/icons";

const CreatorPlatformTitle: React.FC<any> = ({ platform }) => {
  const { t } = useTranslate();
  return (
    <div className="d-flex align-items-center mb-1">
      <span className={"me-2"}>
        <i
          className={PLATFORM_ICONS[platform]}
          style={{ color: PLATFORM_COLORS[platform], fontSize: "20px" }}
        ></i>{" "}
      </span>
      <span className={"text-gray-800"}>
        {t(PLATFORM_DISPLAY_NAME_KEYS_WITH_ALL[platform])}
      </span>
    </div>
  );
};

export default CreatorPlatformTitle;
